import React from "react";
import { isBrowser } from "react-device-detect";
import { useDispatch } from "react-redux";
import { openLabOrderFinishModal, openLabOrderGeneralResultModal } from "../../../../../redux/actions/modals";
import LabOrderSendResultComponent from "../../modals/LabOrderSendResultComponent";
import {getVendorType} from "../../../../../services/auth";

const LabOrderWaitingForResultActions = (props) => {
  const dispatch = useDispatch();
  const vendor_type = getVendorType()

  return (
    <>
      <div className={isBrowser ? "flex-column waiting-for-price-buttons" : "flex-column waiting-for-price-buttons-mobile"}>
        {
          props.order.order_type === 'lab' ? 
          <button
          className="btn btn-small btn-success btn-accept margin-bottom-5"
          onClick={() => {
            dispatch(openLabOrderGeneralResultModal(props.order));
          }}
        >
          ارسال نتیجه
        </button> : null
        }
        <button
          className="btn btn-small btn-primary btn-accept margin-bottom-5"
          disabled={vendor_type === "LAB" ? !props.order.hasTestResult : false}
          onClick={() => {
            dispatch(openLabOrderFinishModal(props.order));
          }}
        >
          تایید نهایی
        </button>
      </div>
      <LabOrderSendResultComponent order={props.order} />
    </>
  );
};
export default LabOrderWaitingForResultActions;
